export default {
  FETCH_THEME_REQUEST: 'FETCH_THEME_REQUEST',
  FETCH_THEME_SUCCESS: 'FETCH_THEME_SUCCESS',
  FETCH_THEME_FAILURE: 'FETCH_THEME_FAILURE',
  UPDATE_THEME: 'UPDATE_THEME',
  SAVE_THEME_REQUEST: 'SAVE_THEME_REQUEST',
  SAVE_THEME_SUCCESS: 'SAVE_THEME_SUCCESS',
  SAVE_THEME_FAILURE: 'SAVE_THEME_FAILURE'
}
